import React from "react"
import PropTypes from "prop-types"
import graphql from "graphql"
import styled from "styled-components"
import { Text } from "rebass"

import Layout from "../containers/Layout"
import Hero from "../containers/Hero"
import Section from "../containers/Section"
import Contact from "../containers/Contact"
import Services from "../containers/Services"

import logo from "../images/logo.svg"

const ContactMessage = styled(Text).attrs({
  fontSize: [2, 3, 4, 5],
  textAlign: `center`,
  my: [`2rem`, `3rem`, `6rem`],
  mx: [`1rem`, `2.5rem`, `6rem`]
})``

export const query = graphql`
  query IndexPageQuery {
    site {
      siteMetadata {
        title
        shortTitle
        description
        copyright
      }
    }
    markdown: allMarkdownRemark(
      sort: { fields: [frontmatter___id], order: ASC }
    ) {
      services: edges {
        service: node {
          frontmatter {
            id
            title
            image {
              childImageSharp {
                sizes(maxWidth: 700) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
          html
        }
      }
    }
  }
`

const Index = ({ data }) => {
  const {
    markdown: { services },
    site: {
      siteMetadata: { title, shortTitle, description, copyright }
    }
  } = data

  return (
    <Layout
      title={title}
      shortTitle={shortTitle}
      copyright={copyright}
      description={description}
    >
      <Hero logo={logo} description={description} />
      <Section title="Services" bg="lightgray">
        <Services services={services} />
      </Section>
      <Section title="Contact" bg="white">
        <ContactMessage>
          Give us a call at <strong>(626) 634-2640</strong>, or fill out the
          form and we'll get back to you.
        </ContactMessage>
        <Contact />
      </Section>
    </Layout>
  )
}

Index.propTypes = {
  data: PropTypes.object
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js